import { memo } from 'react';

import withExposer from '@/hocs/with-exposer';
import useStore from '@/state';
import getNextBreadcrumbTitle from '@/state/selectors/secondary-nav/get-next-breadcrumb-title';
import { BasicComponentProps } from '@/typings/generic';

interface BreadcrumbLinkWithDropdownProps extends BasicComponentProps {
	title?: string;
	toggleDropdown?: () => void;
	dropdownOpen?: boolean;
	index: number;
}

const BreadcrumbLinkWithDropdownComponent: React.FC<
	BreadcrumbLinkWithDropdownProps
> = ({ title, dropdownOpen, toggleDropdown, index }) => {
	const nextBreadcrumbTitle = useStore((state) =>
		getNextBreadcrumbTitle(state, index),
	);

	if (!title) return null;

	return (
		<a
			className='dxnav__breadcrumb-link'
			href='#'
			aria-expanded={dropdownOpen}
			onClick={toggleDropdown}
		>
			<span className='dxnav__breadcrumb-text'>{title}</span>
			{/* 			<span className='dxnav-breadcrumb__ellipsis dxnav-hide'>...</span>
			 */}
			<svg className='dxnav-icon'>
				<use xlinkHref='#Chevron_Right'></use>
			</svg>
			{nextBreadcrumbTitle ? (
				<span className='dxnav__breadcrumb-secondary-title'>
					{nextBreadcrumbTitle}
				</span>
			) : null}
		</a>
	);
};

const BreadcrumbLinkWithDropdown = memo(
	withExposer(
		BreadcrumbLinkWithDropdownComponent,
		'breadcrumb_link_with_dropdown',
	),
);

export default BreadcrumbLinkWithDropdown;
